module.exports = __webpack_public_path__ + "img/resized952016062295201255.1bb0ca80.jpg";